<template>
	<v-card
		tile
		outlined
	>
		<MyMap
			v-bind:content="content"
			v-bind:setActiveWhenLoaded="true"
		/>
	</v-card>
</template>

<script>
	import MyMap from "../map/MyMap";
	import CommonHelper from "../../../components/helpers/CommonHelper";
	import cloneDeep from "lodash/cloneDeep";

	export default {
		props: {
			cfg: Object
		},
		data: function(){
			var data = {
				content: {}
			};
			if (this.cfg) {
				Object.assign(data.content, cloneDeep(this.cfg.data));
			}
			return data;
		},
		components: {
			MyMap
		},
		methods: {
			getPageData4Save: function(){
				var pageData4Save = {
					mapConfig: CommonHelper.getMapConfig(this.content.myMap)
				};
				if (this.content.myMap.myObjectsLayer) {
					pageData4Save.myObjects = [];
					var features = [];
					this.content.myMap.myObjectsLayer.getSource().forEachFeature(function(feature){
						features.push(feature);
					});
					CommonHelper.sortFeatures(features);
					features.forEach(function(feature){
						pageData4Save.myObjects.push({
							coordinates: feature.getGeometry().getCoordinates(),
							attributes: {
								title: feature.get("title"),
								description: feature.get("description")
							},
							color: feature.get("color")
						});
					});
				}
				return pageData4Save;
			}
		}
	}
</script>

<style scoped>
	.v-card {
		height: 100%;
		min-height: 100px;
		overflow: hidden; /* Aktualu tooltip'ui */
	}
</style>